module.exports = __webpack_public_path__ + "static/img/action-jl2.dcfba03c.png";